import script from "./SearchPageSearchResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchResults.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchResults.vue?vue&type=style&index=0&id=b1d59ce2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1d59ce2"]])

export default __exports__